module.exports = __webpack_public_path__ + "img/youzanIronQRCode.39dc36ee.png";